export default __webpack_public_path__ + "static/media/detonation.4d1fe000.png";